import type {
  Meta,
  RaceWithVerification,
  SourceWithFetch,
  VerificationState,
} from './types.ts';

const BASE = import.meta.env.VITE_API_BASE ?? '/api';

async function get<T>(path: string): Promise<T> {
  const response = await fetch(`${BASE}${path}`, { headers: { accept: 'application/json' } });
  if (!response.ok) throw new Error(`${response.status} ${response.statusText}`);
  return (await response.json()) as T;
}

export const api = {
  races: () => get<{ count: number; races: RaceWithVerification[] }>('/races'),
  meta: () => get<Meta>('/meta'),
  sources: () => get<SourceWithFetch[]>('/sources'),
  verification: () => get<VerificationState>('/verification'),
  async startVerification() {
    const response = await fetch(`${BASE}/verification/run`, { method: 'POST' });
    if (!response.ok && response.status !== 202) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return (await response.json()) as { started: boolean; alreadyRunning?: boolean };
  },
};
